import { render, staticRenderFns } from "./ResourceSearch.vue?vue&type=template&id=4d4cf593&"
import script from "./ResourceSearch.vue?vue&type=script&lang=js&"
export * from "./ResourceSearch.vue?vue&type=script&lang=js&"
import style0 from "./ResourceSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports